import {
  FundingProgramAbbreviation,
  TrackingEvent,
  makeBannerTrackingName,
} from "@outschool/funding-programs-shared";
import { northCarolinaEsaFundsLoggedInBannerCtaPath } from "@outschool/routes";
import { ExternalLink, TrackedButton } from "@outschool/ui-components-shared";
import React from "react";

import lightBulbImage from "../../images/home/lightbulb.svg";
import MarketingBanner from "./MarketingBanner";

const title = "Use your ESA+ funds on Outschool";
const description =
  "North Carolina families with Education Student Accounts (ESA+) can now use ClassWallet to access Outschool classes.";
const cta = "Learn How It Works";

const NorthCarolinaESABanner = () => {
  const properties = {
    fundingProgram: FundingProgramAbbreviation.NC,
    component: "NorthCarolinaESABanner",
  };

  return (
    <MarketingBanner
      title={title}
      content={description}
      cta={
        <TrackedButton
          trackViews
          variant="contained"
          trackingViewEventName={makeBannerTrackingName(
            TrackingEvent.BannerView,
          )}
          component={ExternalLink}
          url={northCarolinaEsaFundsLoggedInBannerCtaPath()}
          trackingName={makeBannerTrackingName(TrackingEvent.ProgramUrl)}
          trackingSharedProperties={properties}
        >
          {cta}
        </TrackedButton>
      }
      imagePath={lightBulbImage}
    />
  );
};

export default NorthCarolinaESABanner;
